// 12 scoring abilities — keys MUST match server.py SCORE_ABILITIES order.
export const ABILITIES = [
  { key: "build", label: "Build", hint: "Physical presence / stature for the role" },
  { key: "improvisation", label: "Improvisation", hint: "Reacting on the spot" },
  { key: "confidence", label: "Confidence", hint: "Commitment & self-assurance" },
  { key: "intimidation", label: "Intimidation", hint: "Controlled aggression & ability to unsettle" },
  { key: "creepiness", label: "Creepiness", hint: "Unnerving quality" },
  { key: "vocal_skill", label: "Vocal Skill", hint: "Screams, growls, projection" },
  { key: "movement", label: "Movement", hint: "Body control & physicality" },
  { key: "startle_timing", label: "Startle Timing", hint: "Timing of the scare" },
  { key: "energy", label: "Energy", hint: "Stamina & intensity throughout" },
  { key: "versatility", label: "Versatility", hint: "Range across different characters & scenes" },
  { key: "consistency", label: "Consistency", hint: "Maintains character" },
  { key: "professionalism", label: "Professionalism", hint: "Attitude & direction-taking" },
];

export const ABILITY_LABELS = ABILITIES.reduce((m, a) => ((m[a.key] = a.label), m), {});
